export default __webpack_public_path__ + "static/media/wave_two.ea44d43a.png";